import * as React from "react";
import { KeyboardButtonDefinition } from "./KeyboardButton";
import { KeyboardContext } from "./keyboardContext";
import { getInputValue } from "./keyboardEventHandler";

export interface KeyboardProps {
    readonly input?: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
    readonly children?: React.ReactNode;
}

export class Keyboard extends React.Component<KeyboardProps> {
    constructor(props: KeyboardProps) {
        super(props);
    }

    public render() {
        return (
            <KeyboardContext.Provider value={this.onButtonClicked}>
                {this.props.children}
            </KeyboardContext.Provider>
        );
    }

    private onButtonClicked = (button: KeyboardButtonDefinition) => {
        if (this.props.input && this.props.input.current) {
            const currentValue = this.props.input.current.value;
            this.props.input.current.value = getInputValue(
                this.props.input.current,
                button
            );
            if ((this.props.input.current as any)._valueTracker) {
                (this.props.input.current as any)._valueTracker.setValue(
                    currentValue
                );
            }
            this.props.input.current.dispatchEvent(
                new Event("change", { bubbles: true })
            );
        }
    };
}
